export const AccessCheckElementAccess = {
  HAS_ACCESS: {
    name: 'has-access',
    label: 'Has Access'
  },
  NO_ACCESS_HIDDEN: {
    name: 'no-access-hidden',
    label: 'Does Not Have Access - Hidden'
  },
  NO_ACCESS_VISIBLE: {
    name: 'no-access-visible',
    label: 'Does Not Have Access - Visible'
  },
  LOADING: {
    name: 'loading',
    label: 'Loading'
  }
};